import { Navigate } from "react-router-dom";

export default function HyphensPage() {
  return <Navigate to="/ads?tab=scripts" replace />;
}
